/**
 * @generated SignedSource<<90f51a3858b7836f78d00c2d60d5d55d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type InternScheduledBuildCardTriggerMutation$variables = {
  brandId: string;
  platform: string;
};
export type InternScheduledBuildCardTriggerMutation$data = {
  readonly triggerScheduledBuildNow: {
    readonly message: string;
    readonly pipelineId: string | null;
    readonly success: boolean;
  };
};
export type InternScheduledBuildCardTriggerMutation = {
  response: InternScheduledBuildCardTriggerMutation$data;
  variables: InternScheduledBuildCardTriggerMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "brandId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "platform"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "brandId",
        "variableName": "brandId"
      },
      {
        "kind": "Variable",
        "name": "platform",
        "variableName": "platform"
      }
    ],
    "concreteType": "TriggerScheduledBuildPayload",
    "kind": "LinkedField",
    "name": "triggerScheduledBuildNow",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pipelineId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InternScheduledBuildCardTriggerMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InternScheduledBuildCardTriggerMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3eb38c508eaf908c7620ecbe18b18443",
    "id": null,
    "metadata": {},
    "name": "InternScheduledBuildCardTriggerMutation",
    "operationKind": "mutation",
    "text": "mutation InternScheduledBuildCardTriggerMutation(\n  $brandId: ID!\n  $platform: String!\n) {\n  triggerScheduledBuildNow(brandId: $brandId, platform: $platform) {\n    success\n    message\n    pipelineId\n  }\n}\n"
  }
};
})();

(node as any).hash = "4c657e25850acf3457234ce5bf85ae3f";

export default node;
